import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { Stethoscope, Smile, Sparkles, Heart, Baby, Bone, Ear, Eye, Brain, Activity } from "lucide-react";

const ICON = {
  "general-physician": Stethoscope,
  "dentist": Smile,
  "dermatologist": Sparkles,
  "cardiologist": Heart,
  "gynecologist": Baby,
  "pediatrician": Baby,
  "orthopedic": Bone,
  "ent": Ear,
  "ophthalmologist": Eye,
  "neurologist": Brain,
};

export default function SpecialtiesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/specialties").then((r) => setItems(r.data.items || [])); }, []);
  return (
    <section className="mx-auto max-w-[1280px] px-4 lg:px-6 py-14">
      <Seo title="Browse by specialty" canonicalPath="/specialties" />
      <h1 className="font-display text-3xl md:text-4xl font-bold">Browse by specialty</h1>
      <p className="text-muted-foreground mt-2 max-w-2xl">Pick the care you're looking for — from general consultation to specialist opinions.</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mt-8">
        {items.map((s) => {
          const I = ICON[s.slug] || Activity;
          return (
            <Link key={s.slug} to={`/doctors/pune/${s.slug}`} className="rounded-xl border border-border p-5 card-hover bg-card">
              <span className="h-11 w-11 rounded-xl bg-accent text-[hsl(var(--ld-jade-fg))] grid place-items-center"><I size={22} /></span>
              <h3 className="font-display font-semibold mt-4">{s.name}</h3>
              <p className="text-xs text-muted-foreground mt-1">Find {s.name.toLowerCase()}s near you in Pune.</p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
